
var owlb;
var owl;
Product_slide = {
    init : function(){
        this.getSection();
    },
    getSection : function(){
        var section_ids = $('.product-slide-id');
        section_ids.each(function () {
            Product_slide.buildSlide($(this).data('id'),$('#product-slide-'+$(this).data('id')).data('options'));
        });
    },
    buildSlide : function(id,options){
        $('#product-slide-'+id).owlCarousel({
            //loop:options.infinity,
            autoplay:options.autoplay,
            autoplayTimeout:options.autoplayTimeout,
            autoplayHoverPause:options.autoplayHoverPause,
            margin:0,
            responsiveClass:true,
            responsive:{
                0:{
                    items:1,
                    nav:false
                },
                600:{
                    items:1,
                    nav:false
                },
                1000:{
                    items:1,
                    nav:false
                }
            }
        });
    }
};
Product_slide.init();
Featured_item = {
    init : function(){
        this.getSection();
    },
    getSection : function(){
        var section_ids = $('.featured-item-id');
        section_ids.each(function () {
            Featured_item.buildSlide($(this).data('id'),$('#featured-item-'+$(this).data('id')).data('options'));
        })
    },
    buildSlide : function(id,options){
        $('#featured-item-'+id).owlCarousel({
            margin:options.margin,
            autoplay:options.autoplay,
            autoplayTimeout:options.autoplayTimeout,
            loop:options.loop,
            autoplayHoverPause:options.autoplayHoverPause,
            responsiveClass:true,
            responsive:{
                0:{
                    items:1,
                    nav:false
                },
                600:{
                    items:2,
                    nav:false
                },
                1000:{
                    items:3,
                    nav:false
                }
            }
        });
    }
};
Featured_item.init();
Recent_view = {
    init : function(){
        this.getSection();
    },
    getSection : function(){
        //var section_ids = $('.history-owl');
        //section_ids.each(function () {
            Recent_view.buildSlide(/*$(this).data('id')*/);
        //})
    },
    buildSlide : function(){
        var owl = $(document).find('.history-owl');
        owl.owlCarousel({
            responsiveClass:true,
            margin:20,
            autoplay:true,
            nav:true,
            dots:true,
            responsive:{
                0:{
                    items:1
                },
                600:{
                    items:3
                },
                1000:{
                    items:5
                }
            }
        });
        $('.next-item').click(function() {
            owl.trigger('next.owl.carousel');
        });
        $('.prev-item').click(function() {
            owl.trigger('prev.owl.carousel', [300]);
        });
    }
};
Recent_view.init();
Comming = {
    init : function(){
        this.getSection();
    },
    getSection : function(){
        var section_ids = $('.prepare-comming-id');
        section_ids.each(function () {
            Comming.buildSlide($(this).data('id'));
        })
    },
    buildSlide : function(id){
        var comming = $('#prepare-comming-'+id).owlCarousel({
            margin:0,
            responsiveClass:true,
            //autoHeight:true,
            responsive:{
                0:{
                    items:1
                },
                600:{
                    items:1
                },
                1000:{
                    items:1
                }
            }
        });
        // console.log('resize');
        // comming.trigger('refresh.owl.carousel');
    }
};
Comming.init();
Filter = {
    init : function(){
        this.slide();
        $('.image-sale-product').owlCarousel({
            items:1
        });
    },
    slide : function(){
        var select = $('.sale-item-id');
        select.each(function(){
            Filter.buildFilter($(this).data('id'));
        });
    },
    buildFilter : function(section,options){
        var $owl = $('#sale-product-'+section).owlCarousel({
            margin:0,
            //autoplay:true,
            rewind:true,
            responsive:{
                0:{
                    items:1,
                    nav:false
                },
                600:{
                    items:1,
                    nav:false
                },
                1000:{
                    items:1,
                    nav:false
                }
            }
        });

        $('#'+section).on('click', 'li', function(e) {
            var filter_data = $(this).data('filter');
            console.log(filter_data);
            /* return if current */
            if($(this).hasClass('active')) return;
            /* active current */
            $(this).addClass('active').siblings().removeClass('active');
            /* Filter */
            $owl.owlFilter(filter_data);
        });
    },
};
Filter.init();
List_sidebar = {
    init : function(){
        this.build();
    },
    build : function(){
        var owl = $('#similar-carousel');
        owl.owlCarousel({
            margin:0,
            //autoplay:true,
            autoHeight:true,
            rewind:true,
            margin:10,
            responsive:{
                0:{
                    items:1,
                    nav:false
                },
                600:{
                    items:1,
                    nav:false
                },
                1000:{
                    items:1,
                    nav:false
                }
            }
        });
        $('.nextList').click(function() {
            owl.trigger('next.owl.carousel');
        })
        // Go to the previous item
        $('.prevList').click(function() {
            // With optional speed parameter
            // Parameters has to be in square bracket '[]'
            owl.trigger('prev.owl.carousel', [300]);
        })
        owl.on('changed.owl.carousel',function(property){
            var current = property.item.index;
            var src = $(property.target).find(".owl-item").eq(current).find("img").attr('src');
            console.log('Image current is ' + src);
            console.log(current);
            $('.current').html(current+1);
        });
    }
}
List_sidebar.init();
List_images = {
    init : function(){
        List_images.build();
        $(window).on('resize',function() {
            $('.owl-list-big').trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
            $('.owl-list-big').find('.owl-stage-outer').children().unwrap();

            List_images.build();
        });

    },
    build : function(){
        owl = $('.owl-list');
        owlb = $('.owl-list-big');
        owl.owlCarousel({
            margin:5,
            responsive:{
                0:{
                    items:4,
                    nav:false
                },
                600:{
                    items:4,
                    nav:false
                },
                1000:{
                    items:4,
                    nav:false
                }
            }
        });
        owlb.owlCarousel({
            margin:5,
            autoHeight:true,
            autoHeightClass: 'owl-height',
            responsive:{
                0:{
                    items:1,
                    nav:false
                },
                600:{
                    items:1,
                    nav:false
                },
                1000:{
                    items:1,
                    nav:false
                }
            }
        });
        var mix = 4;
        var active = $('.owl-list-big').find('.owl-item.active');
        var index = active.index();
        var id = active.find('img.img-responsive').data('id');
        var list = $('[data-img="'+id+'"]');
        if(index < mix){
            owl.trigger('to.owl.carousel',[0,200]);
        }else{
            var next = index/mix;
            next = parseInt(next);
            owl.trigger('to.owl.carousel', [next, 200]);
        }
        $(list).parents('.owl-item').siblings('.owl-item').css('opacity','.5');
        $(list).parents('.owl-item').css('opacity','1');

        owlb.on('changed.owl.carousel',function(e){
            var index = e.item.index;
            var data = JSON.parse($('#data-single-product').html());
            var variants = data.variants;
            var id = $(e.target).find('.owl-item').eq(index).find('img.img-responsive').data('id');
            if(index < mix){
                owl.trigger('to.owl.carousel',[0,200]);
            }else{
                var next = index/mix;
                next = parseInt(next);
                owl.trigger('to.owl.carousel', [next, 200]);
            }
            var select = $('[data-img="'+id+'"]');
            $(select).parents('.owl-item').siblings('.owl-item').css('opacity','.5');
            $(select).parents('.owl-item').css('opacity','1');
            $.each(variants,function(i,variant){
                if(variant.featured_image != null){
                    if(id == variant.featured_image.id){
                        $('#variant-id').val(variant.id);
                        window.history.pushState({},'','?variant='+variant.id);
                        $.each(data.options,function(j,option){
                            option = option.toLowerCase();
                            var value = variant.options[j].toLowerCase().replace(/[^A-Z0-9]+/ig, "");
                            $('#'+option).val(value);
                            if(option == 'color' || option == 'colors'){
                                var color_select = $('[data-value="'+value+'"]');
                                console.log(color_select);
                                color_select.siblings('.for-color').removeClass('color-selected');
                                color_select.addClass('color-selected');
                            }
                        });
                        var compare = $('.single-compare-at-price');

                        var price = $('.single-price');

                        if(variant.compare_at_price > variant.price){
                            compare.html('$'+(variant.compare_at_price/100)).show();
                            price.html('$'+(variant.price/100));
                        }else{
                            compare.hide();
                            price.html('$'+(variant.price/100));
                        }

                    }
                }
            })
        });

        $('.owl-list').on('click', '.owl-item', function(e) {
            var id = $(this).find('img').data('img');
            var item = $('[data-img="'+id+'"]');
            var index = $(item).parents('.owl-item').index();
            owlb.trigger('to.owl.carousel',[index,200]);
            $(item).parents('.owl-item').siblings('.owl-item').css('opacity','.5');
            $(item).parents('.owl-item').css('opacity','1');
        });

        $('.nextImg').click(function() {
            owl.trigger('next.owl.carousel');
        })
        // Go to the previous item
        $('.prevImg').click(function() {
            // With optional speed parameter
            // Parameters has to be in square bracket '[]'
            owl.trigger('prev.owl.carousel', [300]);
        })
    }
}
List_images.init();

$(document).ready(function(){
    theme = {
        init : function(){
            this.downmenu();
            this.scrollTo();
            this.changeQuantity();
            this.changeColor();
            this.product();
            this.ImageZoom();
            this.handleresize();
            this.filterMenu();
            this.collectionType();
            this.collapseMenu();
            this.confirmRemove();
            this.changeAddressList();
            this.currentAddressList();
            this.scrollEffect();
            this.quickCart();
            this.effectSearch();
            //this.pageScroll();
        },
        downmenu : function () {
            $('.dropdown-toggle>.fa').on('click',function(e){
                e.preventDefault();
                var element = $(this).parents('a').siblings('.mega');
                if(element.css('display') == 'none'){
                    $(this).removeClass('fa-angle-down').addClass('fa-angle-up')
                    //$('.mega').hide();
                    element.show();
                }else{
                    $(this).removeClass('fa-angle-up').addClass('fa-angle-down')
                    element.hide();
                }
            })
        },
        confirmRemove : function(){
            $('.remove-item').on('click',function(e){
                var del = confirm("Are you sure you want to delete this item ?");
                if(del == false){
                    e.preventDefault();
                }
            });
        },
        scrollTo: function(){
            $(".down-scroll").click(function(e) {
                var $this = $(this);
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: $this.offset().top + 80
                }, 1000);
            });
        },
        changeQuantity : function(){
            this.quantity();
            $(window).on('resize',function () {
                theme.quantity();
            });
        },
        quantity : function(){
            var show = $('.show-xs').find('.change-quantity');
            var hide = $('.line-item-quantity').find('.change-quantity');
            if(window.innerWidth <= 767){
                hide.attr('disabled','disabled');
                show.removeAttr('disabled');
            }else{
                show.attr('disabled','disabled');
                hide.removeAttr('disabled');
            }
        },
        changeColor : function(){
            $('.for-color').on('click',function(){
                var target = $(this).data('target');
                var value = $(this).data('value');
                $(this).siblings('.for-color').removeClass('color-selected');
                $(this).addClass('color-selected');
                console.log('#'+target+',value:' +value);
                $('#'+target).val(value).trigger('change').trigger('change');
            });
        },
        product : function(){
            if($('#data-single-product').html() != undefined) {
                var data = JSON.parse($('#data-single-product').html())
                var select = $('.single-option-variant');
                var variant_id = $('#variant-id');
                var img = $('.container-image-zoom>img');
                var compare = $('.single-compare-at-price');
                var price = $('.single-price');
                theme.selectVariant(data,select,variant_id,img,compare,price);
                select.change(function () {
                    theme.selectVariant(data,select,variant_id,img,compare,price);
                });
            }
        },
        selectVariant : function(data,select,variant_id,img,compare,price){
            var option = [];
            select.each(function () {
                if ($(this).context.localName == 'select') {
                    option.push($(this).val());
                }
            })
            option = option.sort(function(a, b){return a - b}).join(',').replace(/[^A-Z0-9]+/ig, "");
            for (var i in data.variants) {
                var vri = data.variants[i].options.sort(function(a, b){return a - b}).join(',').toLowerCase().replace(/[^A-Z0-9]+/ig, "");
                if (vri === option) {
                    var variant = data.variants[i];
                    variant_id.val(variant.id);
                    window.history.pushState({},'','?variant='+variant.id);
                    $('.single-product-wish-icon').removeClass(function(index, className) {
                        return (className.match(/(^|\s)fav-\S+/g) || []).join(' ');
                    }).addClass('fav-'+variant.id);
                    if(variant.compare_at_price > variant.price){
                        compare.html('$'+(variant.compare_at_price/100)).show();
                        price.html('$'+(variant.price/100));
                    }else{
                        compare.hide();
                        price.html('$'+(variant.price/100));
                    }
                    if(variant.featured_image != null){
                        var id = variant.featured_image.id;
                        var item = $('[data-id="'+id+'"]');
                        var index = $(item).parents('.owl-item').index();
                        owlb.trigger('to.owl.carousel',[index,200]);

                        var img = $(item).parents('.owl-item').index();
                        if(img < 4){
                            owl.trigger('to.owl.carousel',[0,200]);
                        }else{
                            var next = parseInt(img/4);
                            owl.trigger('to.owl.carousel',[next,200]);
                        }
                        var itemimg = $('[data-img="'+id+'"]');
                        $(itemimg).parents('.owl-item').siblings('.owl-item').css('opacity','.5');
                        $(itemimg).parents('.owl-item').css('opacity','1');
                    }
                    break;
                }
            }
        },
        ImageZoom : function(){
            $('.zoom-container').zoom();
            if(window.innerWidth <= 767){
                $('.zoom-container').trigger('zoom.destroy');
            }
            $(window).on('resize',function(){
                if(window.innerWidth <= 767){
                    $('.zoom-container').trigger('zoom.destroy');
                }else{
                    $('.zoom-container').zoom();
                }
            })
        },
        filterMenu : function(){
            $('.btn-coll-filter').on('click',function(){
                if($('.fs-products-filter').hasClass('show-filter')){
                    $('.fs-products-filter').removeClass('show-filter');
                    return;
                }
                $('.fs-products-filter').addClass('show-filter');
            });
        },
        collectionType : function(){
            var filter = $('.collection-filter');
            if (filter.length) {
                var $grid = $('.grid-product').isotope({ filter: '.page-1' });
                $('.grid-product img').bind('load', function () {
                    $grid.isotope({ filter: '.page-1' });
                    //$grid.isotope('layout');
                });
                filter.on('click', 'li', function () {
                    $('.collection-filter li').removeClass('active');
                    $(this).addClass('active');
                    $grid.isotope({ filter: $(this).data('filter') });
                });
            }
        },
        collapseMenu : function(){
            $('.navbar-toggle').on('click',function (e) {
                e.preventDefault();
                var menu = $('.content-menu');
                if(menu.hasClass('in')){
                    menu.collapse('hide');
                    $('.quick-cart-item').css('z-index','');
                }else{
                    $('.quick-cart-item').css('z-index','-1');
                    theme.closeSearchForm();
                    menu.collapse('show');
                }

            })
        },
        changeAddressList : function(){
            $('.next').on('click',function(e){
                e.preventDefault();
                var ct = $('.collapse.in').data('tab');
                console.log(ct);
                if($('.show-shop').hasClass('tab-'+(ct+1))){
                    $('.tab-'+ct).collapse('hide');
                    $('.tab-'+(ct+1)).collapse('show');
                }
            })
            $('.previous').on('click',function(e){
                e.preventDefault();
                var ct = $('.collapse.in').data('tab');
                if($('.show-shop').hasClass('tab-'+(ct-1))){
                    $('.tab-'+ct).collapse('hide');
                    $('.tab-'+(ct-1)).collapse('show');
                }
            })
        },
        currentAddressList : function(){
            var ct = 1;
            $('.tab-'+ct).collapse('show');
        },
        scrollEffect : function(){
            theme.checkPageY();
            $(window).on('scroll',function(){
                theme.checkPageY();
            });
        },
        checkPageY : function(){
            var navigation = $('.navigation-menu');
            var position = navigation.data('position');
            if(position == 'fixed') {
                if (window.pageYOffset > 0) {
                    navigation.addClass(position);
                } else {
                    navigation.removeClass(position);
                }
            }
        },
        quickCart : function(){
            $(document).on('click','.menu-cart',function(){
                if($(document).find('.quick-cart-item').hasClass('in')){
                    $(document).find('.quick-cart-item').collapse('hide');
                    return true;
                }
                $(document).find('.quick-cart-item').css('position','absolute').collapse('show');
            })
        },
        effectSearch : function(){
            $('.menu-search').on('click',function(e){
                e.preventDefault();
                var searchForm = $('.header-search-form');
                if(searchForm.hasClass('in')){
                    searchForm.collapse('hide');
                    return;
                }
                theme.closeCollapseMenu();
                searchForm.collapse('show');
                $('.search-header__input').focus();
            })
            $('.close-search-form').on('click',function(){
                $( '.'+$(this).data('target') ).collapse('hide');
            });
        },
        closeSearchForm : function(){
            $('.header-search-form').collapse('hide');
        },
        closeCollapseMenu: function(){
            $('.content-menu').collapse('hide');
        },
        handleresize : function(){
            $(window).on('resize',function(){
                Product_slide.init();
                Featured_item.init();
                Comming.init();
                Filter.init();
                List_images.init();
                if(window.outerWidth >= 768){
                    $('.mega').css({'display':''});
                }
            });
        },
        pageScroll : function(){
            var $window = $(window);		//Window object

            var scrollTime = .5;			//Scroll time
            var scrollDistance = 300;		//Distance. Use smaller value for shorter scroll and greater value for longer scroll

            $window.on("DOMMouseScroll", function(event){

                event.preventDefault();

                var delta = event.originalEvent.wheelDelta/120 || -event.originalEvent.detail/3;
                var scrollTop = $window.scrollTop();
                var finalScroll = scrollTop - parseInt(delta*scrollDistance);

                TweenMax.to($window, scrollTime, {
                    scrollTo : { y: finalScroll, autoKill:true },
                    ease: Power1.easeOut,	//For more easing functions see https://api.greensock.com/js/com/greensock/easing/package-detail.html
                    autoKill: true,
                    overwrite: 5
                });

            });

        }
    }
    theme.init();
});

$(document)
    .on('shopify:section:load',function(event){
        console.log(event);
        Product_slide.init();
        Featured_item.init();
        Comming.init();
        Filter.init();
        List_images.init();
        theme.init();
    } )
    .on('shopify:section:unload', function(event){
        console.log(event);
        Product_slide.init();
        Featured_item.init();
        Comming.init();
        Filter.init();
        List_sidebar.init();
        List_images.init();
        theme.init();
    })
    .on('shopify:section:select',function(event){
        //var html = $('#shopify-section-'+event.detail.sectionId).data();
        var data = event.target.attributes;
        var array;
        for(var i in data){
            if(data[i].nodeValue.indexOf("}") > 0){
                array = data[i].nodeValue;
                break;
            }
        }
        console.log(JSON.parse(array));
        var section = JSON.parse(array);
        theme.init();
        Recent_view.init();
        List_sidebar.init();
        List_images.init();
        switch (section.type){
            case 'product-slide':
                Product_slide.buildSlide(section.id,$('#product-slide-'+section.id).data('options'));
            break;
            case 'featured-item':
                Featured_item.buildSlide(section.id,$('#featured-item-'+section.id).data('options'));
            break;
            case 'prepare-comming':
                Comming.buildSlide(section.id,$('#prepare-comming-'+section.id).data('options'));
                break;
            case 'sale-product':
                Filter.buildFilter(section.id,$('#sale-product-'+section.id).data('options'));
            break;
            case 'findstore':
                Map.init();
            break;
        }
    } )
    .on('shopify:section:deselect',function(event){
        console.log(event);
        theme.init();
    } )
    .on('shopify:block:select', function(event){
        var section = event.detail;
        theme.init();
    })
    .on('shopify:block:deselect',function(event){
        console.log(event);
        theme.init();
    } );
window.onload = function(e) {
    $('.progress').css('width','100%');
    setTimeout(function(){
        $('.prev-load').fadeOut(100);
    },1000)
};
